import { useCallback, useEffect, useState } from 'react';

import { IconPlay } from '@picsart/design-system/foundation/icons/IconPlay';

import VideoPreview from 'components/VideoPreview';
import { ANALYTICS_NAMES } from 'templates/components/SingleTemplate/constants';

import useDevice from 'hooks/useDeviceType';
import useSingleTemplatesDataStore from 'templates/stores/singleTemplateDataStore';
import Image from 'components/Image';
import Description from '../Description';
import testIds from './testIds';

import useStyles from './style';

const Slider = () => {
  const { isMobile } = useDevice();
  const classes = useStyles();

  const [hovered, setHovered] = useState(true);

  const { templateData } = useSingleTemplatesDataStore(state => ({
    templateData: state.singleTemplateData,
  }));

  const { display_name = '', comment, preview_info } = templateData;

  const videoUrl = templateData?.type_specific_properties?.animated_preview_info?.url;
  const showVideo = videoUrl && hovered;

  useEffect(() => {
    setHovered(true);
    const timeout = setTimeout(() => {
      setHovered(false);
    }, 3000);

    return () => clearTimeout(timeout);
  }, []);

  const handleMouseEnter = useCallback(() => setHovered(true), []);
  const handleMouseLeave = useCallback(() => setHovered(false), []);

  return (
    <section className={classes.section}>
      <div
        className={classes.root}
        data-testid={testIds.root}
        data-pulse-section={ANALYTICS_NAMES.SLIDER}
      >
        <div className={classes.previewWrapper}>
          <div
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            className={classes.contentWrapper}
            data-testid={testIds.videoWrapper}
          >
            <Image imageClassName={classes.image} src={preview_info.url} alt={display_name} />
            {showVideo && <VideoPreview className={classes.videoPreview} src={videoUrl} />}
            {!hovered && videoUrl && (
              <div className={classes.iconWrapper}>
                <IconPlay className={classes.playIcon} data-testid={testIds.playIcon} />
              </div>
            )}
          </div>
        </div>
        {comment && !isMobile && <Description content={comment} />}
      </div>
    </section>
  );
};

export default Slider;
